import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import RiwayatNikahRepository from '../Repositories/RiwayatNikahRepository'

class RiwayarNikahBloc {
    
    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    activeChannel = new Subject();
    pendidikanChannel = new Subject()
    repository = new RiwayatNikahRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.activeChannel.next({status: apiResponse.INITIAL})
        this.pendidikanChannel.next({ status: apiResponse.INITIAL }) 
    }

    fetchRowTable = async (query, cancelToken) => {
        this.rowtableChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchInactive = async (query) => {
        this.inactiveChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchActive = async (query) => {
        this.activeChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchActive(query).then((result) => {
                this.activeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.activeChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }


    fetchPendidikan = async (query) => {
        this.pendidikanChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchPendidikan(query).then((result) => {
                this.pendidikanChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.pendidikanChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Pendidikan Channel Unsubscribed')
        }
    }


}

export default RiwayarNikahBloc 
